import useResourceList from './useResourceList';

import api from '..';

export const useLiveBlogsList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'liveBlogs', api: api.liveBlogs }, queryVariables, queryConfig);

  return {
    liveBlogs: queryResult.resolvedData,
    latestsLiveBlogs: queryResult.latestData,
    ...queryResult,
  };
};
